export default "__VITE_ASSET__Dxo3Fesz__"